import React from 'react';
import PropTypes from 'prop-types';

import BodyText from 'components/widget/BodyText';
import { FullWidthPageContent } from 'layouts/SingleColumnLayout';
import LensPlanOptions from 'components/widgets/LensPlanOptions';

import styled from 'styled-components';
import Button from 'components/Button';
import InfoBox from 'components/widget/InfoBox';
import IncludeSolutionWidget from '../components/widgets/IncludeSolutionWidget';

const Wrapper = styled.div`
  .topSection {
    margin-bottom: ${({ theme }) => theme.spacing * 3}px;
  }

  .solutionCheckBox {
    margin-top: ${({ theme }) => theme.spacing}px;
  }

  .formCta {
    padding: ${({ theme }) => theme.spacing * 2}px;
    > * {
      margin-bottom: ${({ theme }) => theme.spacing * 2}px;
    }
  }
`;

const OrderTopupsView = ({
  className, plans, onSubmit, onCancel, usage, maxTopup, solution,
}) => {
  const classes = ['OrderTopupsView', className];
  const [planId, setPlanId] = React.useState();
  const [withSolution, setWithSolution] = React.useState(
    solution && solution.selected,
  );

  function manageChange(value) {
    setPlanId(value);
  }

  function handleSubmit(e) {
    e.preventDefault();
    onSubmit({
      planId,
      withSolution,
    });
  }

  return (
    <Wrapper className={classes.filter((c) => !!c).join(' ')}>
      <div className="topSection">
        <h1 className="no_margin_top">Order Top-ups</h1>
        <BodyText>
          Choose amount needed. Top-ups usually arrive within 3-5 working days*
        </BodyText>
      </div>

      <FullWidthPageContent as="form" onSubmit={handleSubmit}>
        <LensPlanOptions plans={plans} onChange={manageChange} dataLayerAction="Top Up" />
        {solution && (
          <IncludeSolutionWidget
            className="solutionCheckBox"
            solution={solution}
            selected={withSolution}
            onChange={(e) => setWithSolution(e.target.checked)}
          />
        )}
        <div className="formCta">
          <Button
            disabled={!planId}
            fullWidth
            type="submit"
            dataLayer={{ action: 'Top Up', label: 'Review Order' }}
          >
            Review your order
          </Button>
          <Button inverse fullWidth type="button" onClick={onCancel}>
            Cancel
          </Button>
        </div>
      </FullWidthPageContent>
      <InfoBox asterisk>
        Most lenses will arrive within 3-5 working days, however certain less
        common prescriptions may not be in stock and may take up to 28 days to
        arrive.
        <p>
          As you&apos; re on the&nbsp;
          {usage}
          &nbsp;package you can order top-ups of up
          to&nbsp;
          {maxTopup}
          &nbsp;pairs.
        </p>
      </InfoBox>
    </Wrapper>
  );
};

OrderTopupsView.displayName = 'OrderTopupsView';

OrderTopupsView.propTypes = {
  className: PropTypes.string,
  plans: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  maxTopup: PropTypes.number.isRequired,
  usage: PropTypes.string.isRequired,
  solution: PropTypes.shape({
    selected: PropTypes.bool,
  }),
};

OrderTopupsView.defaultProps = {
  className: undefined,
  solution: undefined,
};

export default OrderTopupsView;
